import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetFilteredToursWithException } from './useGetFilteredToursWithException'
import { getDestinationsData } from '../redux/reducers/destinations'
import { getFilterSetFromTourResults } from '../utilities/content/content'

export function useGetFilterContentFromResults(filterKey, localFilterState = {}) {
  const destinations = useSelector(getDestinationsData)
  const searchResults = useGetFilteredToursWithException(filterKey, localFilterState)

  return useMemo(() => {
    return getFilterSetFromTourResults(destinations, filterKey, searchResults)
  }, [destinations, filterKey, searchResults])
}
